module.exports = __webpack_public_path__ + "public/img/yibiaopan_lv_21.96cc7fdb.png";